import { PostTagsTheme } from '../../../themeConstants'

const styles = {
    flatFlags: {
        flexDirection: 'row',
        borderRadius: 5,
        borderWidth: 0.5,
        borderColor: PostTagsTheme.tagSelectedColor,
        paddingHorizontal: 10,
        height: 30,
        alignItems: 'center',
        textAlign: 'center',
        justifyContent: 'center',
    },
    flatItemsSelected: {
        fontWeight: 'bold',
        fontSize: 15,
        color: PostTagsTheme.tagSelectedTextColor,
    },
    flatItemsUnselected: {
        fontWeight: 'bold',
        fontSize: 15,
        color: PostTagsTheme.tagUnselectedTextColor,
    },
}

export default styles
